(() => {
  if(window.PPCartBundles)return;
  const properties=value=>Array.isArray(value)?Object.fromEntries(value):value||{};
  const lines=(items,id)=>items.filter(i=>properties(i.properties)._pp_starter_id===id);
  const fingerprint=items=>JSON.stringify(items.map(i=>[i.key,String(i.variant_id||i.id),i.quantity]).sort((a,b)=>a[0].localeCompare(b[0])));
  const count=items=>new Set(items.map(i=>properties(i.properties)._pp_starter_id).filter(Boolean)).size+items.filter(i=>!properties(i.properties)._pp_starter_id).reduce((n,i)=>n+i.quantity,0);
  async function remove(controller,id,snapshot,page){
    const cart=await controller.request(controller.config.root+'cart.js');
    const current=lines(cart.items,id);
    if(!current.length||fingerprint(current)!==fingerprint(snapshot)){await controller.refresh();throw new Error(controller.t('changed'));}
    const updates=Object.fromEntries(current.map(i=>[i.key,0]));
    if(page)await controller.post('update',{updates});
    else {
      const result=await controller.request(controller.config.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates,sections:[controller.config.sectionId],sections_url:controller.config.cartUrl})});
      await controller.applyResponse(result);
    }
    controller.message(controller.t('bundle_removed'));
  }
  window.PPCartBundles={lines,fingerprint,count,remove};
})();